import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProjectDeletionService, ProjectDeletionPreview } from '../../../services/project-deletion.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-project-deletion-confirm',
  templateUrl: './project-deletion-confirm.component.html',
  styleUrls: ['./project-deletion-confirm.component.scss']
})
export class ProjectDeletionConfirmComponent {
  @Input() projectId!: number;
  @Input() isVisible = false;
  @Output() closed = new EventEmitter<void>();

  step: 1 | 2 = 1;
  loading = false;
  starting = false;
  preview: ProjectDeletionPreview | null = null;
  typedName = '';

  constructor(private svc: ProjectDeletionService, private toast: ToastService, private router: Router) {}

  async open(): Promise<void> {
    this.isVisible = true; this.step = 1; this.typedName = ''; this.preview = null; this.loading = true;
    try { this.preview = await firstValueFrom(this.svc.preview(this.projectId)); }
    catch { this.toast.showToast('error', 'No se pudo calcular el impacto del borrado.'); this.close(); }
    finally { this.loading = false; }
  }
  get canContinue(): boolean { return !!this.preview && this.preview.canDelete; }
  get nameMatches(): boolean { return !!this.preview && this.typedName.trim() === this.preview.projectName.trim(); }
  goStep2(): void { if (this.canContinue) this.step = 2; }
  async confirmDelete(): Promise<void> {
    if (!this.nameMatches || this.starting) return;
    this.starting = true;
    try {
      const { batchId } = await firstValueFrom(this.svc.start(this.projectId, this.typedName.trim()));
      this.close();
      this.router.navigate(['/dashboard/admin/project-deletion', batchId]);
    } catch (err: any) {
      const msg = err?.error?.message ?? 'Error iniciando el borrado.';
      this.toast.showToast('error', msg);
    } finally { this.starting = false; }
  }
  close(): void { this.isVisible = false; this.closed.emit(); }
}
